<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'OrderList' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'TradeRecord' }"
              tag="button"
              class="active"
            >
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main">
          <div class="bg-box">
            <h1>{{ $t("卡片交易紀錄") }}</h1>
          </div>
          <div class="bg-box">
            <div class="search-box">
              {{ $t("依日期查詢") }}
              <hr />
              <div class="search">
                <input
                  class="form-control"
                  id="sDate"
                  name="sDate"
                  type="date"
                />
                <p>{{ $t("至") }}</p>
                <input
                  class="form-control"
                  id="eDate"
                  name="eDate"
                  type="date"
                />
              </div>
              <div class="box">
                <button @click="tradeRecord()">{{ $t("查詢") }}</button>
              </div>
            </div>
            <p class="notice-box">
              {{ $t("*查詢區間目前僅開放扣款日前一年查詢-到三天前") }}
            </p>
          </div>
          <hr :class="IsLoaded ? 'result-boxadd' : ''" />
          <div
            class="bg-box result-box"
            :class="IsLoaded ? 'result-boxadd' : ''"
          >
            <h1>{{ $t("查詢結果") }}</h1>
            <hr />
            <div class="result" v-if="ErrorMsg != ''">
              <p>{{ ErrorMsg }}</p>
            </div>
            <div class="result" v-if="ErrorMsg == ''">
              <p>
                <span>{{ sDate }}</span> {{ $t("至") }}
                <span>{{ eDate }}</span> ，{{ $t("共") }}{{ Count
                }}{{ $t("筆") }}
              </p>
              <ul
                class="text-box"
                v-for="TradeRecord in TradeRecords"
                :key="TradeRecord.TraceNo"
              >
                <li>
                  <div>{{ TradeRecord.TransactionDate }}</div>
                  <div>{{ TradeRecord.xtype }}</div>
                </li>
                <li>
                  <div>{{ TradeRecord.PartnerLoc }}</div>
                  <div>
                    {{ TradeRecord.Sign + TradeRecord.AMT2 }}{{ $t("元") }}
                  </div>
                </li>
                <li>
                  <div>{{ $t("餘額") }}</div>
                  <div>{{ TradeRecord.ElectronicValue }}{{ $t("元") }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    會員資料: "會員資料",
    我的套票: "我的套票",
    卡片資料: "卡片資料",
    套票兌換: "套票兌換",
    卡片交易記錄: "卡片交易記錄",
    其他資訊: "其他資訊",
    依日期查詢: "依日期查詢",
    至: "至",
    查詢: "查詢",
    "*查詢區間目前僅開放扣款日前一年查詢-到三天前":
      "*查詢區間目前僅開放扣款日前一年查詢-到三天前",
    查詢結果: "查詢結果",
    共: "共",
    筆: "筆",
    元: "元",
    餘額: "餘額",
    錯誤: "錯誤",
    "取得交易紀錄過程發生錯誤, 請稍後再試一次":
      "取得交易紀錄過程發生錯誤, 請稍後再試一次",
    確定: "確定",
    卡片交易紀錄: "卡片交易紀錄",
    減碳計算: "減碳計算",
  },
  en: {
    會員資料: "Member info",
    我的套票: "My pass",
    卡片資料: "Card info",
    套票兌換: "Redeem pass",
    卡片交易記錄: "Card record",
    其他資訊: "Other info",
    依日期查詢: "Query by date",
    至: "To",
    查詢: "Query",
    "*查詢區間目前僅開放扣款日前一年查詢-到三天前":
      "* Query period: between 1 year before deduction date and 3 days before deduction date.",
    查詢結果: "Query result",
    共: "Total",
    筆: "Entries",
    元: "NT$",
    餘額: "Balance",
    錯誤: "Error",
    "取得交易紀錄過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    確定: "Confirm",
    卡片交易紀錄: "Activity",
    減碳計算: "Carbon Reduced",
  },
  jp: {
    會員資料: "マイページ",
    我的套票: "購入/予約履歴",
    卡片資料: "卡片資料",
    套票兌換: "フリーパス引き換え",
    卡片交易記錄: "カード取引履歴",
    其他資訊: "其他資訊",
    依日期查詢: "日付で検索する",
    至: "至",
    查詢: "検索",
    "*查詢區間目前僅開放扣款日前一年查詢-到三天前":
      "*検索期間は利用日の一年から三日前と限られます。",
    查詢結果: "查詢結果",
    共: "共",
    筆: "筆",
    元: "元",
    餘額: "餘額",
    錯誤: "錯誤",
    "取得交易紀錄過程發生錯誤, 請稍後再試一次":
      "取得交易紀錄過程發生錯誤, 請稍後再試一次",
    確定: "確定",    
    卡片交易紀錄: "カード取引履歴",
    減碳計算: "減碳計算",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "TicketLog",
  i18n,
  data() {
    return {
      TradeRecords: [],
      Count: 0,
      sDate: "",
      eDate: "",
      ErrorMsg: "",
      IsLoaded: false,
      local: "zh_tw",
    };
  },
  created: function () {},
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-record");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  methods: {
    timeString(time, format) {
      return moment(time).format(format || "YYYY-MM-DD, HH:mm:ss");
    },
    tradeRecord() {
      this.IsLoaded = false;
      this.ErrorMsg = "";
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/TradeRecord",
        type: "post",
        data: {
          token: Storage.get("ek_login_token"),
          sDate: $("#sDate").val(),
          eDate: $("#eDate").val(),
        },
        dataType: "json",
        error: function () {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: that.$t("取得交易紀錄過程發生錯誤, 請稍後再試一次"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.TradeRecords = JSON.parse(res.TradeRecords);
            that.Count = res.Count;
            that.sDate = res.sDate;
            that.eDate = res.eDate;
            that.IsLoaded = true;
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            if (res.toekn_error) {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                willClose: function () {
                  // 移除登入資訊
                  Storage.remove("ek_login_token");
                  // 回到首頁
                  that.$router.push({
                    name: "Home",
                    params: {},
                  });
                },
              });
            } else {
              that.IsLoaded = true;
              that.ErrorMsg = res.error;
            }
          }
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TradeRecord.vue